import axios, { AxiosResponse } from "axios";
import { TableData } from "../../models/dtos/base/TableData";
import { QueryPagesDTO } from "../../models/query-strings/base/QueryPagesDTO";
import { CourseNoteEditionView } from "../../models/views/education/CourseNoteEditionView";
import CourseNoteCourseTitleValue from "../../models/views/education/CourseNoteCourseTitleValue";
import CourseNoteCourseView from "../../models/views/education/CourseNoteCourseView";
import BaseService from "../base/BaseService";

export default class CourseNoteService extends BaseService {
    getPages(queryInfo: QueryPagesDTO): Promise<TableData<CourseNoteEditionView>> {
        return axios.get(`/CourseNote/Student`, { params: queryInfo })
            .then(function (response: AxiosResponse<TableData<CourseNoteEditionView>, any>) {
                return response.data;
            });
    }

    getCourseTitleValues(): Promise<CourseNoteCourseTitleValue[]> {
        return axios.get(`/CourseNote/Student/Courses/TitleValues`)
            .then(function (response: AxiosResponse<CourseNoteCourseTitleValue[], any>) {
                return response.data;
            });
    }

    getCourses(courseId: number, courseNoteCategoryId: number): Promise<CourseNoteCourseView[]> {
        return axios.get(`/CourseNote/Student/Courses`, {
            params: { courseId, courseNoteCategoryId }
        }).then(function (response: AxiosResponse<CourseNoteCourseView[], any>) {
            return response.data;
        });
    }
}
